<script>
import { h, Transition } from 'vue'
import VTabsHeader from './v-tabs-header.vue'
export default {
  props: {
    modelValue: { type: Number, required: false, default: 0 },
    isAnimated: { type: Boolean, required: false, default: true },
    hasLabels: { type: Boolean, required: false, default: true },
    isHeaderVisible: { type: Boolean, required: false, default: true },
    isLabelVisible: { type: Boolean, required: false, default: false },
    items: { type: Array, required: true },
    style: { type: Object, required: false, default: {} },
    colorActive: { type: String, required: false, default: '#ff781f' },
  },
  data() { 
    return {
      vnodes: this.$slots.default().filter(e => e.type.name == 'v-tabs-content'),
      transitionName: null,
    }
  },
  render() {
    return h('div',
      { style: 'position:relative' }, 
      [
        !this.isHeaderVisible ? h('div') :
        h(VTabsHeader, {
          items: this.items,
          style: this.style,
          hasLabels: this.hasLabels,
          colorActive: this.colorActive,
          isLabelVisible: this.isLabelVisible,
          modelValue: this.modelValue,
          'onUpdate:modelValue': value => this.$emit('update:modelValue', value)
        }),
        h(Transition, 
          { name: this.transitionName, mode: "out-in" }, 
          _ => this.vnodes[this.modelValue]
        )
      ]
    )
  },
  watch: {
    'items.length'() {
      this.vnodes = this.$slots.default().filter(e => e.type.name == 'v-tabs-content')
    },
    modelValue(val, oldVal) {
      window.scrollTo(0,0)
      if (val > oldVal) this.transitionName = 'slide-left'
      if (val < oldVal) this.transitionName = 'slide-right'
    }
  }
}
</script>